import React from 'react';
import { Truck, Wrench, Phone } from 'lucide-react';
export function TopBar() {
  return <div className="bg-brand-green text-white py-2 px-4 text-sm font-medium" data-id="element-685" data-mp="3c0c69usjao2b">
      <div className="max-w-7xl mx-auto flex justify-center items-center text-center" data-id="element-686" data-mp="2y01e8ofhn3fk">
        {/* Mobile View */}
        <div className="md:hidden flex items-center justify-center gap-3 space-x-2" data-id="element-687" data-mp="321d5eye0fwpv">
          <span className="flex items-center gap-1.5" data-id="element-688" data-mp="3pr7hhdqi9h92">
            <Truck size={14} data-id="element-689" data-mp="3prr2j3bgclrb" /> Nationwide shipping
          </span>
          <span className="opacity-50" data-id="element-690" data-mp="3uqtyzzdd9jno">•</span>
          <a href="tel:301-620-7585" className="flex items-center gap-1.5 hover:text-brand-gold transition-colors" data-id="element-691" data-mp="3upiqxncw1pqr">
            <Phone size={14} data-id="element-692" data-mp="3kzphot07xmpo" /> Call 301-620-7585
          </a>
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex items-center justify-center gap-4" data-id="element-693" data-mp="ckfhjqfw2rkj">
          <span className="flex items-center gap-1.5" data-id="element-694" data-mp="hb5pnbfp98ix">
            <Truck size={16} data-id="element-695" data-mp="hcp5j0xg1hk6" /> Nationwide shipping
          </span>
          <span className="opacity-50" data-id="element-696" data-mp="2n4adzup3vrww">•</span>
          <span className="flex items-center gap-1.5" data-id="element-697" data-mp="2n2zg2bicdedp">
            <Wrench size={16} data-id="element-698" data-mp="2i70ka2uoou39" /> Installation available in select Mid-Atlantic
            areas
          </span>
          <span className="opacity-50" data-id="element-699" data-mp="2wvn8ku2agw6m">•</span>
          <a href="tel:301-620-7585" className="flex items-center gap-1.5 hover:text-brand-gold transition-colors" data-id="element-700" data-mp="2s459kbjtt5oa">
            <Phone size={16} data-id="element-701" data-mp="35u8m2aswll0j" /> Call 301-620-7585
          </a>
        </div>
      </div>
    </div>;
}